export default __webpack_public_path__ + "media/images/borders/orange-border-3a13fa65a3a48d80a32319c9a7be5dc1.svg";